// extracted by mini-css-extract-plugin
export default {"wrap":"ChatEmbed_wrap__CP13W","body":"ChatEmbed_body__RKqKo","frame":"ChatEmbed_frame__TyB9b"};